<section class="role-wrapper">
    <h2 [hidden]="loading">{{ 'settingsDialog.managementRoles' | translate}}</h2>
    <loading-indicator [show]="loading"></loading-indicator>
    <kendo-panelbar [expandMode]="'single'">
        <kendo-panelbar-item title="" #kendoPanel *ngFor="let role of roles; let i = index;">
            <ng-template kendoPanelBarItemTitle>
                <label>{{role.description}}</label>
            </ng-template>
            <ng-template kendoPanelBarContent>
                <section style="margin:0px 15px; display: flex; width: 100%;" >
                    <kendo-grid #grid id="grid-{{ i }}" [kendoGridBinding]="role.assignments" kendoGridSelectBy="oid" 
                        [(selectedKeys)]="mySelection" [pageSize]="10" [pageable]="true"  
                        [scrollable]="'scrollable'" [height]="530" style="width: 98%;"
                        [filterable]="'menu'" (remove)="removeHandler($event, role)" (cancel)="cancelHandler($event)" 
                        (add)="addHandler($event, role.oid)" (edit)="onEdit($event, role)">
                        <ng-template kendoGridToolbarTemplate>
                            <button style="width:100% !important"  kendoGridAddCommand>{{'common.addRecord' | translate }}</button>
                        </ng-template>
                        <kendo-grid-column field="oid" [hidden]="true"></kendo-grid-column>
                        <kendo-grid-column field="userDescription" [title]="'settingsDialog.name' | translate"
                            [width]="250">
                            <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                                <kendo-dropdownlist [data]="filteredUsers" [(ngModel)]="selectedUser" [valuePrimitive]="true"
                                    [filterable]="true" (filterChange)="handleFilter($event)"
                                    [textField]="'User_Description'" [valueField]="'OID'" (valueChange)="addAssignment(role.oid, role)">
                                </kendo-dropdownlist>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-command-column [width]="20">
                            <ng-template kendoGridCellTemplate>
                                <button kendoGridRemoveCommand>{{'common.delete' | translate  }}</button>
                             
                                <button  kendoGridCancelCommand>
                                    {{'common.delete' | translate }}
                                  </button>
                            </ng-template>
                        </kendo-grid-command-column>
                    </kendo-grid>
                </section>
            </ng-template>
        </kendo-panelbar-item>
    </kendo-panelbar>
   
</section>
<kendo-dialog
*ngIf="displatConfirmationDialog"
(close)="confirmRemove(false)"
[minWidth]="250"
[width]="450"
>
<p style="margin: 30px; text-align: center;">
  Are you sure you want to delete this item?
</p>
<kendo-dialog-actions>
  <button class="role-wrapper-kendo-action-btn" kendoButton (click)="confirmRemove(false)">No</button>
  <button
    kendoButton
    themeColor="primary"
    (click)="confirmRemove(true)" class="role-wrapper-kendo-action-btn"
    [primary]="true"
  >
    Yes
  </button>
</kendo-dialog-actions>
</kendo-dialog>
